import { fork } from 'redux-saga/effects'

import * as watchers from './setupform-watchers'

export default [
  fork(watchers.watchSetupformLoad),
  fork(watchers.watchSetupformLoadSuccess),
  fork(watchers.watchSetupformUpdateBasic),
  fork(watchers.watchSetupformUpdateAdvanced),
  fork(watchers.watchSetupformSubmit),
  fork(watchers.watchUpdateVenueSearchResults),
  fork(watchers.watchEventTypesLoad),
  fork(watchers.watchCropperSave),
  fork(watchers.watchCropperReset),
  fork(watchers.watchSetupformDelete),
  fork(watchers.watchSetupformAddNewVoucher),
  fork(watchers.watchSetupformAddNewVoucherApiSuccess),
  fork(watchers.watchSetupformEditVoucher),
  fork(watchers.watchSetupformStartDeletingVoucher),
  fork(watchers.watchSetupformStartCopyingVoucher),
  fork(watchers.watchSetupformSetAsNoVenue),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/setupform/index.js
 **/